// filepath: d:\Projet\Nouzha-Palace\frontend\src\services\invoiceRequestService.js
import api from './api';

const invoiceRequestService = {
  // Create a new invoice request
  createInvoiceRequest: async (reservationId, reservationType, contactInfo) => {
    try {
      const response = await api.post('/invoice-requests', {
        reservationId,
        reservationType,
        contactInfo
      });
      
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error creating invoice request:', error);
      return {
        success: false,
        error: error.response?.data?.message || error.message
      };
    }
  },
  
  // Get invoice request status
  getInvoiceRequestStatus: async (requestId) => {
    try {
      const response = await api.get(`/invoice-requests/${requestId}`);
      
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error fetching invoice request:', error);
      return {
        success: false,
        error: error.response?.data?.message || error.message
      };
    }
  }
};

export default invoiceRequestService;